import { faMapPin, faPhoneFlip } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { heroGirlHuggingDog } from 'assets/images';
import clsx from 'clsx';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightImageColumn } from 'components/Layout/TwoColumns/RightImageColumn/RightImageColumn';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { useMarketplace, useMarketplaceAddress } from 'hooks/useMarketplace';
import { usePhoneFormat } from 'hooks/usePhoneFormat';
import React from 'react';

import classes from './OnlineBookingDisabled.module.scss';

export const OnlineBookingDisabled: React.FC = () => {
    const marketplace = useMarketplace();
    const { marketplaceAddress } = useMarketplaceAddress();
    const formattedPhone = usePhoneFormat(marketplace.phone || '');

    return (
        <TwoColumnsLayout>
            <LeftColumn contentClassName="flex flex-col flex-1 gap-4 justify-center">
                <img className={classes.logo} src={marketplace.logo}></img>

                <h1 className={clsx('h1', classes.title)}>Online booking currently unavailable</h1>

                <p>We&apos;re sorry, but our online booking service is currently unavailable.</p>

                <p>
                    If you would like to schedule an appointment or have any questions, please do
                    not hesitate to reach out to us:
                </p>

                <div>
                    <p className={classes.detailInfo}>{marketplace.name}</p>
                    {marketplace.phone && (
                        <a href={`tel:+1${marketplace.phone}`} className={classes.detailInfo}>
                            <span>
                                <FontAwesomeIcon icon={faPhoneFlip} />
                            </span>
                            {formattedPhone}
                        </a>
                    )}
                    <p className={classes.detailInfo}>
                        <span>
                            <FontAwesomeIcon icon={faMapPin} />
                        </span>
                        {marketplaceAddress}
                    </p>
                </div>

                <p>We look forward to seeing you soon!</p>

                <div className={classes.footer}>
                    <PoweredByCuddles />
                </div>
            </LeftColumn>

            <RightImageColumn image={heroGirlHuggingDog} />
        </TwoColumnsLayout>
    );
};
